import React, { useState } from "react";
import {
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Tooltip,
} from "@material-ui/core";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";

const RowActionsMenu = ({ actions = [], buttonTitle = "Acoes", disabled = false }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const availableActions = actions.filter((action) => !action.hidden);

  const handleOpen = (event) => {
    if (disabled || availableActions.length === 0) {
      return;
    }

    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Tooltip title={buttonTitle}>
        <span>
          <IconButton size="small" onClick={handleOpen} disabled={disabled || availableActions.length === 0}>
            <MoreHorizIcon fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        {availableActions.map((action) => {
          const Icon = action.icon;

          return (
            <MenuItem
              key={action.key}
              onClick={() => {
                handleClose();
                if (typeof action.onClick === "function") {
                  action.onClick();
                }
              }}
              disabled={action.disabled}
            >
              {Icon ? (
                <ListItemIcon>
                  <Icon fontSize="small" color={action.color || "inherit"} />
                </ListItemIcon>
              ) : null}
              <ListItemText primary={action.label} />
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
};

export default RowActionsMenu;
